import React from 'react';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import Input from '~/components/input';
import moment from 'moment';

interface ProposalSectionProps {
  form: Record<string, any>;
  isSenff: boolean;
}

const ProposalSection: React.FC<ProposalSectionProps> = ({ form, isSenff }) => {
  return (
    <ContainerFlex marginLeft={26} marginRight={26}>
      <Grid xs={1} lg={2} gap={30}>
        <ContainerFlex>
          <Input
            label="Canal"
            value={form.propOrigemDoCadastro.value}
            readOnly
          />

          <Input
            label="Loja do Cadastro/Proposta"
            value={
              isSenff
                ? form.propLojaDoCadastro.value
                : form.propOrigemDoCadastro.value !== 'LOJA'
                ? form.propOrigemDoCadastro.value
                : form.propLojaDoCadastro.value
            }
            readOnly
          />
          <Input
            label="Status da proposta"
            value={form.propStatus.value}
            readOnly
          />
          <Input
            label="Tipo de aprovação"
            value={
              form.propStatusAprovacao.value === 'APROVADA_MESA_CREDITO'
                ? 'MESA'
                : 'AUTOMÁTICO'
            }
            readOnly
          />
        </ContainerFlex>

        <ContainerFlex>
          <Input
            label="Operador(a) de Venda"
            value={
              form.propOrigemDoCadastro.value === 'SITE'
                ? 'WEB'
                : form.propDigitador.value
            }
            readOnly
          />
          <ContainerFlex row height={5}>
            <ContainerFlex marginRight={16}>
              <Input
                label="Data Proposta"
                value={moment(form.propDataCadastro.value).format('DD/MM/YYYY')}
              />
            </ContainerFlex>

            <ContainerFlex>
              <Input
                label="Horário"
                value={moment(form.propDataCadastro.value).format('HH:mm:ss')}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex row height={5}>
            <ContainerFlex marginRight={16}>
              <Input
                label="Data Aprovação"
                value={moment(form.dataAprovacao.value).format('DD/MM/YYYY')}
              />
            </ContainerFlex>

            <ContainerFlex>
              <Input
                label="Horário"
                value={moment(form.dataAprovacao.value).format('HH:mm:ss')}
              />
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex>
            <Input
              label="Responsável pela aprovação"
              value={
                form.propStatusAprovacao.value === 'APROVADA_MESA_CREDITO'
                  ? form.propNomeOperador.value
                  : ''
              }
              readOnly
            />
          </ContainerFlex>
        </ContainerFlex>
      </Grid>
    </ContainerFlex>
  );
};

export default ProposalSection;
